"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnOnce = void 0;
var warnings = new Set(); // eslint-disable-next-line import/prefer-default-export

var warnOnce = function warnOnce(warning) {
  if (!warnings.has(warning)) {
    warnings.add(warning);
    console.warn(warning);
  }
};

exports.warnOnce = warnOnce;